import React from "react";

/*
 * Recriação fiel (em CSS puro) do Dashboard Imobiliário.
 * Paleta própria do produto — não acompanha o tema do portfólio,
 * para parecer um screenshot real da aplicação.
 */

const NAV = [
  "Comercial",
  "Financeiro",
  "Performance",
  "Alertas & Saúde",
  "Velocidade",
];

const FUNNEL = [
  { label: "Prospecção", w: 100, v: 15 },
  { label: "Visita", w: 64, v: 9 },
  { label: "Proposta", w: 42, v: 6 },
  { label: "Fechamento", w: 24, v: 3 },
  { label: "Venda", w: 15, v: 2 },
];

function DashboardPreview() {
  return (
    <div className="browser" aria-hidden="true">
      <div className="browser-bar">
        <div className="browser-dots">
          <i />
          <i />
          <i />
        </div>
        <span className="browser-url">app.dashboard-imobiliario</span>
      </div>

      <div className="dash">
        {/* Sidebar */}
        <aside className="dash-side">
          <div className="dash-brand">
            Dashboard
            <br />
            Imobiliário
          </div>
          {NAV.map((item, i) => (
            <div key={item} className={`dash-navitem ${i === 0 ? "active" : ""}`}>
              <i />
              {item}
            </div>
          ))}
          <div className="dash-user">
            <b />
            demo@bi-imob.app
          </div>
        </aside>

        {/* Conteúdo */}
        <main className="dash-main">
          <div className="dash-head">
            <h4>Indicadores</h4>
            <div className="dash-tabs">
              <span className="dash-tab active">Geral</span>
              <span className="dash-tab">Captação</span>
              <span className="dash-tab">Vendas</span>
            </div>
            <span className="dash-period">Jun · 2026</span>
          </div>

          {/* KPIs */}
          <div className="dash-kpis">
            <div className="kpi kpi--hot">
              <span className="kpi-label">Propostas Quentes</span>
              <span className="kpi-value">R$ 2.100.000</span>
              <span className="kpi-sub">6 oportunidades em negociação</span>
              <span className="kpi-hotfoot">↗ +8% vs mês ant.</span>
            </div>

            <div className="kpi">
              <span className="kpi-label">VGV — Trimestre</span>
              <span className="kpi-value">R$ 7,7M</span>
              <div className="kpi-bar">
                <span style={{ width: "86%" }} />
              </div>
              <div className="kpi-meta">
                <span>Meta 9M</span>
                <span>86%</span>
              </div>
            </div>

            <div className="kpi">
              <span className="kpi-label">VGV — Anual</span>
              <span className="kpi-value">R$ 7,7M</span>
              <div className="kpi-bar">
                <span style={{ width: "86%" }} />
              </div>
              <div className="kpi-meta">
                <span>Meta 9M</span>
                <span>86%</span>
              </div>
            </div>
          </div>

          {/* Painéis */}
          <div className="dash-panels">
            <div className="dash-panel">
              <h5>Funil de Vendas</h5>
              {FUNNEL.map((f) => (
                <div className="funnel-row" key={f.label}>
                  <span>{f.label}</span>
                  <span className="funnel-track">
                    <i style={{ width: `${f.w}%` }} />
                  </span>
                  <span>{f.v}</span>
                </div>
              ))}
            </div>

            <div className="dash-panel">
              <h5>Inventário &amp; Estoque</h5>
              <div className="inv-card">
                <div className="l">Praça Joinville</div>
                <div className="v">R$ 52.000.000</div>
                <div className="m">
                  <span>60 unidades</span>
                  <span>ticket R$ 866k</span>
                </div>
              </div>
              <div className="inv-card">
                <div className="l">Praça Litoral</div>
                <div className="v">R$ 15.000.000</div>
                <div className="m">
                  <span>10 unidades</span>
                  <span>ticket R$ 1,5M</span>
                </div>
              </div>
            </div>
          </div>
        </main>
      </div>
    </div>
  );
}

export default DashboardPreview;
